module.exports = __webpack_public_path__ + "images/emoji/leo.c4cdf0ea6b01ff0c688c.png";